<div [formGroup]="parentForm">
  <div formArrayName="teams">
    @for (team of teamsForm.controls; track team; let teamIndex = $index) {
      <div class="team"
        [formGroupName]="''+teamIndex"
        >
        <div fxLayout="row" fxLayoutGap="2rem">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'vehicles.vehicle' | translate }}</mat-label>
            <mat-select placeholder="{{ 'vehicles.vehicle' | translate }}" formControlName="vehicle" (selectionChange)="onVehicleChange($event, team)">
              @for (vehicle of vehicles; track vehicle) {
                <mat-option [value]="vehicle['@id']" [disabled]="assignedVehicleIds.includes(vehicle['@id'])">
                  {{ vehicle.licensePlate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (vehicleConflicts[team.get('vehicle').value]) {
            <app-alert-message type="warning" [message]="'tourDetails.messages.vehicleConflict' | translate" [@showWarning]>
            </app-alert-message>
          }
        </div>
        <div class="content-drivers" fxLayout="row wrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
          <mat-form-field appearance="outline">
            <mat-select placeholder="{{ 'drivers.driver' | translate }} 1" formControlName="mainDriver">
              @for (driver of drivers; track driver) {
                <mat-option [value]="driver['@id']" [disabled]="assignedDriverIds.includes(driver['@id'])">
                  {{ driver.lastName }} {{ driver.firstName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div formArrayName="additionalDrivers" fxLayout="row wrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
            @for (driverControl of team.get('additionalDrivers').controls; track driverControl; let driverIndex = $index) {
              <mat-form-field class="content-time" appearance="outline">
                <mat-select placeholder="{{ 'drivers.driver' | translate }} {{ driverIndex +2 }}" [formControlName]="driverIndex">
                  @for (driver of drivers; track driver) {
                    <mat-option [value]="driver['@id']" [disabled]="assignedDriverIds.includes(driver['@id'])">
                      {{ driver.lastName }} {{ driver.firstName }}
                    </mat-option>
                  }
                </mat-select>
                <button type="button" mat-mini-fab *ngxPermissionsOnly="['ROLE_USER']" color="primary" class="remove-driver-button" (click)="onRemoveDriver(team, driverIndex)" [title]="'tourDetails.actions.removeDriver' | translate">
                  <mat-icon class="material-icons">remove</mat-icon>
                </button>
              </mat-form-field>
            }
          </div>
          <button type="button" mat-mini-fab *ngxPermissionsOnly="['ROLE_USER']" color="primary" (click)="onAddDriver(team)">
            <mat-icon class="material-icons">add</mat-icon>
          </button>
        </div>
        <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="primary" type="button" (click)="onRemoveTeam(teamIndex)">
          <mat-icon class="material-icons">remove</mat-icon>
          {{ 'tourDetails.actions.removeTeam' | translate }}
        </button>
      </div>
    }
  </div>

  <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="primary" type="button" (click)="onAddTeam()">
    <mat-icon class="material-icons">add</mat-icon>
    {{ 'tourDetails.actions.addTeam' | translate }}
  </button>
</div>
